import { render, staticRenderFns } from "./RedeemVoucherTemplate.vue?vue&type=template&id=7b01b138&"
import script from "./RedeemVoucherTemplate.vue?vue&type=script&lang=js&"
export * from "./RedeemVoucherTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports